define([], () => ({
  RECEIVE_AUTOMATION: 'RECEIVE_AUTOMATION',
  RECEIVE_AUTOMATIONS: 'RECEIVE_AUTOMATIONS',
  UPDATE_AUTOMATION: 'UPDATE_AUTOMATION',
  RECEIVE_AUTOMATIONS_SUBSCRIBERS_LIST: 'RECEIVE_AUTOMATIONS_SUBSCRIBERS_LIST',
}));
